var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.766 3.538l15.905.975c.551.031.915.499.814 1.037l-1.302 6.469c-.1.542-.63.981-1.182.981H7.066l.23 1H18.5a1 1 0 110 2h-12a1 1 0 01-.974-.775L2.633 3.19 1.07 2.405a1 1 0 11.893-1.79l1.984.99a1 1 0 01.528.67l.292 1.263zM18.339 11l.947-4.57-14.05-.86L6.603 11H18.34zM17 21a2 2 0 110-4 2 2 0 010 4zm-9 0a2 2 0 110-4 2 2 0 010 4z",
    fill: "#FA3C00",
    fillRule: "evenodd"
  })));
}

export default SvgCart;